(function () {
  'use strict';

  var path = String(window.location.pathname || '').replace(/\/$/, '').toLowerCase();

  var compactPages = {
    '/pages/50-hour-fork-shock-service': {
      note: 'Best for suspension that is working correctly and due for routine maintenance. If we find an internal fault or worn parts, we will contact you before any additional work.'
    },
    '/pages/100-hour-suspension-service': {
      note: 'A complete internal service for suspension due for full maintenance or showing a drop in performance. Additional worn or damaged parts are confirmed before fitting.'
    },
    '/pages/fork-lower-leg-bushing-replacement': {
      note: 'For fork bushing work, send the complete uppers, lower legs and axle so alignment can be checked correctly before and after the repair.'
    },
    '/pages/suspension-fault-diagnosis-repairs': {
      note: 'We inspect and diagnose the fault first. If repair work or replacement parts are required, we will contact you before proceeding.'
    },
    '/pages/fork-custom-tuning': {
      note: 'We assess compression and rebound behaviour, configure the valving to suit the rider and bike, service the damper as part of the tune and supply baseline settings.'
    },
    '/pages/rear-shock-custom-tuning': {
      note: 'We assess the shock and frame requirements, configure the valving to suit the rider and bike, service the damper as part of the tune and supply baseline settings.'
    },
    '/pages/dropper-post-servicing': {
      note: 'Service scope depends on the dropper model and parts support. If additional repair work is needed, we will contact you before proceeding.'
    }
  };

  var pageConfig = compactPages[path];
  if (!pageConfig) return;

  function normalise(value) {
    return String(value || '').replace(/\s+/g, ' ').trim();
  }

  function enableLink(link, href) {
    if (!link || !href) return;
    link.setAttribute('href', href);
    link.removeAttribute('role');
    link.removeAttribute('aria-disabled');
  }

  function fixPrimaryActions(page) {
    var heroButtons = page.querySelectorAll('.cjs-service-hero .cjs-button-group .cjs-button');

    Array.prototype.forEach.call(heroButtons, function (button) {
      var text = normalise(button.textContent).toLowerCase();

      if (/book/.test(text)) {
        enableLink(button, '/pages/book-a-suspension-service');
      } else {
        button.remove();
      }
    });

    var sidebarPrimary = page.querySelector('.cjs-service-card__actions .cjs-button--primary');
    var sidebarSecondary = page.querySelector('.cjs-service-card__actions .cjs-button--outline');

    enableLink(sidebarPrimary, '/pages/book-a-suspension-service');
    enableLink(sidebarSecondary, '/pages/send-suspension-by-courier');
  }

  function removeDisplayedPrices(page) {
    Array.prototype.forEach.call(
      page.querySelectorAll('.cjs-price, .cjs-price__note, .cjs-related-card__price'),
      function (node) {
        node.remove();
      }
    );

    var serviceCard = page.querySelector('.cjs-service-card');
    var heading = serviceCard ? serviceCard.querySelector('.cjs-service-card__heading') : null;

    if (serviceCard && heading && !serviceCard.querySelector('.cjs-service-pricing-note')) {
      var note = document.createElement('p');
      note.className = 'cjs-service-pricing-note';
      note.textContent = 'Current pricing and availability are shown when you book.';
      heading.insertAdjacentElement('afterend', note);
    }
  }

  function findIncludedBlock(blocks) {
    var found = null;

    blocks.some(function (block) {
      var heading = block.querySelector('.cjs-section-heading');
      var title = normalise(heading ? heading.textContent : '').toLowerCase();

      if (/what is included|what's included|service includes|what we do/.test(title)) {
        found = block;
        return true;
      }

      return false;
    });

    return found || blocks[0] || null;
  }

  function stripLongFormContent(page) {
    var content = page.querySelector('.cjs-service-content');
    if (!content) return;

    var blocks = Array.prototype.slice.call(content.querySelectorAll(':scope > .cjs-content-section--block'));
    var included = findIncludedBlock(blocks);
    var intro = content.querySelector(':scope > .cjs-content-section--intro');

    blocks.forEach(function (block) {
      if (block !== included) block.remove();
    });

    if (included && intro && included.previousElementSibling !== intro) {
      intro.insertAdjacentElement('afterend', included);
    }

    Array.prototype.forEach.call(
      content.querySelectorAll(':scope > .cjs-related-services, :scope > .cjs-faq-section, :scope > .cjs-inline-cta, :scope > .cjs-service-more'),
      function (node) {
        node.remove();
      }
    );

    if (included && !content.querySelector('.cjs-service-good-to-know')) {
      var note = document.createElement('aside');
      note.className = 'cjs-service-good-to-know';
      note.innerHTML = '<span>Good to know</span><p>' + pageConfig.note + '</p>';
      included.insertAdjacentElement('afterend', note);
    }
  }

  function simplifySidebar(page) {
    var details = page.querySelectorAll('.cjs-service-detail');

    Array.prototype.forEach.call(details, function (item, index) {
      if (index > 2) item.remove();
    });

    var sidebarNote = page.querySelector('.cjs-service-card__note');
    if (sidebarNote) sidebarNote.remove();
  }

  function addStyles() {
    if (document.getElementById('cjs-service-page-compact-styles')) return;

    var style = document.createElement('style');
    style.id = 'cjs-service-page-compact-styles';
    style.textContent =
      '.cjs-service-page--compact .cjs-service-hero{min-height:350px!important;}' +
      '.cjs-service-page--compact .cjs-service-hero__content{padding-top:46px!important;padding-bottom:46px!important;}' +
      '.cjs-service-page--compact .cjs-breadcrumbs{margin-bottom:17px!important;font-size:12px!important;}' +
      '.cjs-service-page--compact .cjs-service-logo{margin-bottom:16px!important;}' +
      '.cjs-service-page--compact .cjs-service-logo__image{width:min(255px,100%)!important;max-height:72px!important;}' +
      '.cjs-service-page--compact .cjs-service-hero__copy{max-width:760px!important;}' +
      '.cjs-service-page--compact .cjs-service-hero__title{font-size:clamp(36px,4vw,56px)!important;line-height:1!important;max-width:780px!important;}' +
      '.cjs-service-page--compact .cjs-service-hero__text{max-width:670px!important;font-size:15px!important;line-height:1.55!important;margin-top:13px!important;}' +
      '.cjs-service-page--compact .cjs-button-group{margin-top:22px!important;}' +
      '.cjs-service-page--compact .cjs-trust-bar{display:none!important;}' +
      '.cjs-service-page--compact .cjs-service-main{padding-top:42px!important;padding-bottom:54px!important;}' +
      '.cjs-service-page--compact .cjs-service-layout{grid-template-columns:minmax(0,1fr) minmax(280px,340px)!important;gap:32px!important;align-items:start!important;}' +
      '.cjs-service-page--compact .cjs-content-section--intro{margin-bottom:18px!important;padding:0 0 22px!important;border-bottom:1px solid var(--cjs-border,#e6e2dd)!important;}' +
      '.cjs-service-page--compact .cjs-content-section--intro .cjs-section-heading{font-size:clamp(27px,2.8vw,38px)!important;line-height:1.08!important;margin-bottom:11px!important;}' +
      '.cjs-service-page--compact .cjs-content-section--intro .cjs-rte--large{font-size:14px!important;line-height:1.6!important;max-width:760px!important;}' +
      '.cjs-service-page--compact .cjs-content-section--intro .cjs-rte--large p{margin-bottom:8px!important;}' +
      '.cjs-service-page--compact .cjs-content-section--block{margin:0!important;padding:27px 28px!important;border:1px solid var(--cjs-border,#e6e2dd)!important;border-radius:12px!important;background:var(--cjs-card-background,#fff)!important;box-shadow:none!important;}' +
      '.cjs-service-page--compact .cjs-content-section--block .cjs-section-eyebrow{margin-bottom:8px!important;font-size:10px!important;}' +
      '.cjs-service-page--compact .cjs-content-section--block .cjs-section-heading{font-size:clamp(23px,2.35vw,32px)!important;line-height:1.08!important;margin-bottom:12px!important;}' +
      '.cjs-service-page--compact .cjs-content-section--block .cjs-rte{font-size:13.5px!important;line-height:1.58!important;}' +
      '.cjs-service-page--compact .cjs-content-section--block .cjs-rte ul{display:grid!important;grid-template-columns:repeat(2,minmax(0,1fr))!important;gap:8px 23px!important;margin:12px 0 0!important;}' +
      '.cjs-service-page--compact .cjs-content-section--block .cjs-rte li{margin:0!important;}' +
      '.cjs-service-good-to-know{margin-top:14px;padding:18px 20px;border:1px solid var(--cjs-border,#e6e2dd);border-radius:10px;background:#f7f5f2;}' +
      '.cjs-service-good-to-know span{display:block;margin-bottom:5px;color:var(--cjs-accent,#a8323a);font-size:10px;font-weight:850;line-height:1.3;letter-spacing:.12em;text-transform:uppercase;}' +
      '.cjs-service-good-to-know p{margin:0;color:var(--cjs-secondary-text,#606060);font-size:12.5px;line-height:1.55;}' +
      '.cjs-service-page--compact .cjs-service-sidebar{position:sticky!important;top:110px!important;}' +
      '.cjs-service-page--compact .cjs-service-card{padding:24px!important;border-radius:12px!important;box-shadow:0 8px 24px rgba(17,17,17,.045)!important;}' +
      '.cjs-service-page--compact .cjs-service-card__label{margin-bottom:8px!important;font-size:10px!important;}' +
      '.cjs-service-page--compact .cjs-service-card__heading{font-size:25px!important;line-height:1.08!important;margin-bottom:10px!important;}' +
      '.cjs-service-page--compact .cjs-service-pricing-note{margin:0 0 14px!important;color:var(--cjs-secondary-text,#606060)!important;font-size:12px!important;line-height:1.5!important;}' +
      '.cjs-service-page--compact .cjs-service-details{margin-top:15px!important;}' +
      '.cjs-service-page--compact .cjs-service-detail{padding:9px 0!important;}' +
      '.cjs-service-page--compact .cjs-service-card__actions{margin-top:17px!important;}' +
      '@media(max-width:999px){.cjs-service-page--compact .cjs-service-layout{grid-template-columns:1fr!important;}.cjs-service-page--compact .cjs-service-sidebar{position:static!important;}.cjs-service-page--compact .cjs-service-card{max-width:none!important;}.cjs-service-page--compact .cjs-service-card__actions{display:grid!important;grid-template-columns:repeat(2,minmax(0,1fr))!important;gap:10px!important;}}' +
      '@media(max-width:749px){.cjs-service-page--compact .cjs-service-hero{min-height:330px!important;}.cjs-service-page--compact .cjs-service-hero__content{padding-top:38px!important;padding-bottom:38px!important;}.cjs-service-page--compact .cjs-service-logo__image{width:min(210px,100%)!important;max-height:62px!important;}.cjs-service-page--compact .cjs-service-main{padding-top:30px!important;padding-bottom:40px!important;}.cjs-service-page--compact .cjs-content-section--block{padding:21px 18px!important;}.cjs-service-page--compact .cjs-content-section--block .cjs-rte ul{grid-template-columns:1fr!important;}.cjs-service-page--compact .cjs-service-card__actions{grid-template-columns:1fr!important;}}';

    document.head.appendChild(style);
  }

  function run() {
    var page = document.querySelector('.cjs-service-page');
    if (!page || page.hasAttribute('data-cjs-compact-v4-ready')) return;

    page.setAttribute('data-cjs-compact-v4-ready', '');
    page.classList.add('cjs-service-page--compact');

    addStyles();
    fixPrimaryActions(page);
    removeDisplayedPrices(page);
    stripLongFormContent(page);
    simplifySidebar(page);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  document.addEventListener('shopify:section:load', function () {
    window.requestAnimationFrame(run);
  });
})();

/**
 * CJSUSPENSION final launch-audit polish.
 * Runs after the shared CJS page scripts and keeps cross-page presentation
 * rules consistent without changing Shopify service-library data.
 */
(function () {
  'use strict';

  function currentPath() {
    return String(window.location.pathname || '').replace(/\/$/, '').toLowerCase();
  }

  function normalise(value) {
    return String(value || '').replace(/\s+/g, ' ').trim().toLowerCase();
  }

  function removeSharedModelCardPrices() {
    document.querySelectorAll('.cjs-model-card-note').forEach(function (note) {
      if (/\$\s*\d/i.test(String(note.textContent || ''))) note.remove();
    });
  }

  function condenseWorkshopSupport() {
    var list = document.querySelector('.cjs-model-support ul');
    if (!list) return;

    var items = Array.prototype.slice.call(list.querySelectorAll('li')).map(function (item) {
      return String(item.textContent || '').replace(/\s+/g, ' ').trim();
    }).filter(Boolean);

    if (!items.length) return;

    var chosen = [];
    var used = {};

    function pick(pattern) {
      if (chosen.length >= 5) return;

      for (var i = 0; i < items.length; i += 1) {
        if (used[i] || !pattern.test(items[i])) continue;
        used[i] = true;
        chosen.push(items[i]);
        return;
      }
    }

    pick(/^25hr\b/i);
    pick(/^50hr\b/i);
    pick(/^100hr\b/i);
    pick(/vacuum|damper servicing|complete damper|damper service/i);
    pick(/custom.*tuning|tuning where supported/i);
    pick(/spring.*setup|air[- ]volume|bushing/i);
    pick(/fault diagnosis|function testing|repair/i);

    for (var i = 0; i < items.length && chosen.length < 5; i += 1) {
      if (used[i] || /nationwide|courier/i.test(items[i])) continue;
      used[i] = true;
      chosen.push(items[i]);
    }

    var nationwide = items.find(function (item) {
      return /nationwide|courier/i.test(item);
    });

    if (nationwide && chosen.indexOf(nationwide) === -1) chosen.push(nationwide);

    chosen = chosen.slice(0, 6);

    if (!nationwide && chosen.length < 6) {
      for (var j = 0; j < items.length && chosen.length < 6; j += 1) {
        if (chosen.indexOf(items[j]) === -1) chosen.push(items[j]);
      }
    }

    var signature = chosen.join('||');
    if (list.getAttribute('data-cjs-support-signature') === signature) return;

    list.textContent = '';
    chosen.forEach(function (text) {
      var item = document.createElement('li');
      item.textContent = text;
      list.appendChild(item);
    });
    list.setAttribute('data-cjs-support-signature', signature);
  }

  function ensureSecondaryButton(card, label, href) {
    if (!card || !href) return;

    var existing = card.querySelector('[data-cjs-bos-progressivity-link]');
    if (existing) {
      existing.href = href;
      existing.textContent = label;
      return;
    }

    var primary = card.querySelector('a.cjs-model-button');
    if (!primary) return;

    var secondary = document.createElement('a');
    secondary.className = 'cjs-model-button secondary';
    secondary.href = href;
    secondary.textContent = label;
    secondary.target = '_blank';
    secondary.rel = 'noopener';
    secondary.setAttribute('data-cjs-bos-progressivity-link', '');
    primary.insertAdjacentElement('afterend', secondary);
  }

  function wireBosProgressivityKits() {
    var path = currentPath();
    var config = null;

    if (path === '/pages/bos-kirk') {
      config = {
        label: 'View BOS Kirk Progressivity Kit',
        href: 'https://www.bos-suspension.com/PBCPPlayer.asp?ID=2155806'
      };
    } else if (path === '/pages/bos-void') {
      config = {
        label: 'View BOS Void / Void 2 Progressivity Kit',
        href: 'https://www.bos-suspension.com/PBCPPlayer.asp?ID=2156726'
      };
    }

    if (!config) return;

    document.querySelectorAll('.cjs-model-card').forEach(function (card) {
      var heading = card.querySelector('h3');
      if (normalise(heading ? heading.textContent : '').indexOf('air volume spacer setup') === -1) return;
      ensureSecondaryButton(card, config.label, config.href);
    });
  }

  function fixFastUpgradeLanguage() {
    if (currentPath() !== '/pages/fast-suspension-service') return;

    document.querySelectorAll('[data-cjs-brand-performance-upgrades] a').forEach(function (link) {
      var text = normalise(link.textContent);
      if (text.indexOf('book fast service') === -1 && text.indexOf('book fast upgrade') === -1) return;

      var label = link.querySelector('span:first-child');
      if (label) label.textContent = 'Book FAST Service or Upgrade';
      else link.textContent = 'Book FAST Service or Upgrade';
      link.href = '/pages/book-a-suspension-service';
    });
  }

  function addBosServiceFamilies() {
    if (currentPath() !== '/pages/bos-suspension-service') return;

    var directory = document.querySelector('[data-cjs-brand-model-directory]');
    if (!directory) return;

    var groups = directory.querySelectorAll('.cjs-brand-model-directory__group');
    var rearGroup = null;

    Array.prototype.forEach.call(groups, function (group) {
      var heading = group.querySelector('h3');
      if (normalise(heading ? heading.textContent : '') === 'rear shocks') rearGroup = group;
    });

    if (rearGroup) {
      var list = rearGroup.querySelector('.cjs-brand-model-directory__models');
      if (list) {
        [
          ['Stoy Family', 'cjs-bos-stoy-family'],
          ['Syors Family', 'cjs-bos-syors-family']
        ].forEach(function (entry) {
          if (list.querySelector('[data-cjs-bos-family="' + entry[1] + '"]')) return;

          var item = document.createElement('li');
          var link = document.createElement('a');
          link.href = '/pages/book-a-suspension-service';
          link.textContent = entry[0];
          link.setAttribute('data-cjs-bos-family', entry[1]);
          item.appendChild(link);
          list.appendChild(item);
        });
      }
    }

    document.querySelectorAll('.cjs-brand-performance-upgrades__card').forEach(function (card) {
      var heading = card.querySelector('h3');
      if (!/sar.*sprindex|sprindex.*sar/i.test(heading ? heading.textContent : '')) return;

      var models = card.querySelector('.cjs-brand-performance-upgrades__models');
      if (models) {
        models.innerHTML = '<strong>Confirmed range:</strong> BOS Stoy / Stoy Rare / Stoy 3 / Stoy 4 and Syors / Syors 2 coil-shock families. Exact spring dimensions and rate are confirmed before fitment.';
      }
    });
  }

  function runLaunchAuditPolish() {
    removeSharedModelCardPrices();
    condenseWorkshopSupport();
    wireBosProgressivityKits();
    fixFastUpgradeLanguage();
    addBosServiceFamilies();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runLaunchAuditPolish);
  } else {
    runLaunchAuditPolish();
  }

  window.setTimeout(runLaunchAuditPolish, 120);
  window.setTimeout(runLaunchAuditPolish, 500);
  window.setTimeout(runLaunchAuditPolish, 1500);

  document.addEventListener('shopify:section:load', function () {
    window.requestAnimationFrame(runLaunchAuditPolish);
  });
})();